import React, { useState } from 'react';
import { Upload, FileText, Trash2, Download, Calendar } from 'lucide-react';

const KBUpload = () => {
  const [incidentFiles, setIncidentFiles] = useState([
    { name: 'incident-response-guide.pdf', size: '2.4 MB', uploadedAt: '2024-11-20', uploadedBy: 'admin@echostar.com' },
    { name: 'troubleshooting-playbook.pdf', size: '1.8 MB', uploadedAt: '2024-11-18', uploadedBy: 'admin@echostar.com' },
    { name: 'escalation-procedures.docx', size: '856 KB', uploadedAt: '2024-11-15', uploadedBy: 'admin@echostar.com' }
  ]);

  const [policyFiles, setPolicyFiles] = useState([
    { name: 'change-management-policy.pdf', size: '3.2 MB', uploadedAt: '2024-11-22', uploadedBy: 'admin@echostar.com' },
    { name: 'security-guidelines.pdf', size: '4.1 MB', uploadedAt: '2024-11-19', uploadedBy: 'admin@echostar.com' },
    { name: 'deployment-standards.pdf', size: '2.7 MB', uploadedAt: '2024-11-17', uploadedBy: 'admin@echostar.com' },
    { name: 'compliance-requirements.docx', size: '1.5 MB', uploadedAt: '2024-11-10', uploadedBy: 'admin@echostar.com' }
  ]);

  const handleFileUpload = (type) => {
    console.log(`Upload to ${type}`);
  };

  const handleDelete = (type, fileName) => {
    console.log(`Delete ${fileName} from ${type}`);
  };

  const handleDownload = (fileName) => {
    console.log(`Download ${fileName}`);
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 relative">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-accent opacity-[0.08] blur-[150px] rounded-full pointer-events-none animate-pulse" 
           style={{ animationDuration: '4s' }} />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-accent opacity-[0.06] blur-[150px] rounded-full pointer-events-none animate-pulse" 
           style={{ animationDuration: '5s', animationDelay: '1s' }} />

      <div className="mb-6 relative z-10">
        <h2 className="text-2xl font-bold text-cyan-accent mb-1 tracking-tight" 
            style={{ textShadow: '0 0 30px #00e5ff, 0 0 60px #00e5ff' }}>
          KB Upload
        </h2>
        <p className="text-sm text-gray-500">Upload documents to knowledge bases</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 relative z-10">
        {/* ITOps Advisor Upload */}
        <div className="bg-dark-card border border-dark-border rounded-lg p-6 relative overflow-hidden group hover:border-orange-accent/40 transition-all"
             style={{ background: '#141414', boxShadow: '0 0 30px rgba(0, 0, 0, 0.5), 0 0 2px rgba(255, 107, 53, 0.2)' }}>
          <div className="absolute inset-0 bg-gradient-to-br from-orange-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          
          <div className="flex items-center space-x-3 mb-6 relative z-10">
            <div className="w-10 h-10 rounded-lg bg-orange-accent/10 flex items-center justify-center border border-orange-accent/30"
                 style={{ boxShadow: '0 0 20px rgba(255, 107, 53, 0.2)' }}>
              <Upload size={20} className="text-orange-accent" style={{ filter: 'drop-shadow(0 0 8px currentColor)' }} />
            </div>
            <div>
              <h3 className="text-lg font-bold text-white" style={{ textShadow: '0 0 10px rgba(255,255,255,0.3)' }}>
                ITOps Advisor KB
              </h3>
              <p className="text-xs text-gray-500">{incidentFiles.length} documents</p>
            </div>
          </div>

          <div className="mb-6 relative z-10">
            <label className="block w-full cursor-pointer">
              <div className="border-2 border-dashed border-orange-accent/40 rounded-lg p-8 text-center hover:border-orange-accent/60 hover:bg-orange-accent/5 transition-all"
                   style={{ boxShadow: '0 0 20px rgba(255, 107, 53, 0.1)' }}>
                <Upload size={32} className="mx-auto mb-3 text-orange-accent" style={{ filter: 'drop-shadow(0 0 10px currentColor)' }} />
                <p className="text-sm font-medium text-white mb-1">Click to upload or drag and drop</p>
                <p className="text-xs text-gray-500">PDF, DOCX, TXT (max 10MB)</p>
              </div>
              <input type="file" className="hidden" onChange={() => handleFileUpload('incident')} />
            </label>
          </div>

          <div className="space-y-2 relative z-10">
            <h4 className="text-sm font-semibold text-gray-400 mb-3">Current Documents</h4>
            {incidentFiles.map((file, idx) => (
              <div key={idx} className="flex items-center justify-between p-3 bg-dark-border/40 rounded-lg border border-dark-border/50 hover:border-orange-accent/40 hover:bg-orange-accent/5 transition-all">
                <div className="flex items-center space-x-3 flex-1 min-w-0">
                  <FileText size={18} className="text-orange-accent flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-white truncate">{file.name}</p>
                    <div className="flex items-center space-x-3 text-xs text-gray-500">
                      <span>{file.size}</span>
                      <span>•</span>
                      <span className="flex items-center space-x-1">
                        <Calendar size={12} />
                        <span>{file.uploadedAt}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-2 flex-shrink-0 ml-3">
                  <button 
                    onClick={() => handleDownload(file.name)}
                    className="p-2 hover:bg-cyan-accent/20 rounded transition-colors"
                  >
                    <Download size={16} className="text-cyan-accent" />
                  </button>
                  <button 
                    onClick={() => handleDelete('incident', file.name)}
                    className="p-2 hover:bg-orange-accent/20 rounded transition-colors"
                  >
                    <Trash2 size={16} className="text-orange-accent" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Company Policy Upload */}
        <div className="bg-dark-card border border-dark-border rounded-lg p-6 relative overflow-hidden group hover:border-purple-accent/40 transition-all"
             style={{ background: '#141414', boxShadow: '0 0 30px rgba(0, 0, 0, 0.5), 0 0 2px rgba(178, 75, 243, 0.2)' }}>
          <div className="absolute inset-0 bg-gradient-to-br from-purple-accent/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          
          <div className="flex items-center space-x-3 mb-6 relative z-10">
            <div className="w-10 h-10 rounded-lg bg-purple-accent/10 flex items-center justify-center border border-purple-accent/30"
                 style={{ boxShadow: '0 0 20px rgba(178, 75, 243, 0.2)' }}>
              <Upload size={20} className="text-purple-accent" style={{ filter: 'drop-shadow(0 0 8px currentColor)' }} />
            </div>
            <div>
              <h3 className="text-lg font-bold text-white" style={{ textShadow: '0 0 10px rgba(255,255,255,0.3)' }}>
                Company Policy KB
              </h3>
              <p className="text-xs text-gray-500">{policyFiles.length} documents</p>
            </div>
          </div>

          <div className="mb-6 relative z-10">
            <label className="block w-full cursor-pointer">
              <div className="border-2 border-dashed border-purple-accent/40 rounded-lg p-8 text-center hover:border-purple-accent/60 hover:bg-purple-accent/5 transition-all"
                   style={{ boxShadow: '0 0 20px rgba(178, 75, 243, 0.1)' }}>
                <Upload size={32} className="mx-auto mb-3 text-purple-accent" style={{ filter: 'drop-shadow(0 0 10px currentColor)' }} />
                <p className="text-sm font-medium text-white mb-1">Click to upload or drag and drop</p>
                <p className="text-xs text-gray-500">PDF, DOCX, TXT (max 10MB)</p>
              </div>
              <input type="file" className="hidden" onChange={() => handleFileUpload('policy')} />
            </label>
          </div>

          <div className="space-y-2 relative z-10">
            <h4 className="text-sm font-semibold text-gray-400 mb-3">Current Documents</h4>
            {policyFiles.map((file, idx) => (
              <div key={idx} className="flex items-center justify-between p-3 bg-dark-border/40 rounded-lg border border-dark-border/50 hover:border-purple-accent/40 hover:bg-purple-accent/5 transition-all">
                <div className="flex items-center space-x-3 flex-1 min-w-0">
                  <FileText size={18} className="text-purple-accent flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-white truncate">{file.name}</p>
                    <div className="flex items-center space-x-3 text-xs text-gray-500">
                      <span>{file.size}</span>
                      <span>•</span>
                      <span className="flex items-center space-x-1">
                        <Calendar size={12} />
                        <span>{file.uploadedAt}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-2 flex-shrink-0 ml-3">
                  <button 
                    onClick={() => handleDownload(file.name)}
                    className="p-2 hover:bg-cyan-accent/20 rounded transition-colors"
                  >
                    <Download size={16} className="text-cyan-accent" />
                  </button>
                  <button 
                    onClick={() => handleDelete('policy', file.name)}
                    className="p-2 hover:bg-purple-accent/20 rounded transition-colors"
                  >
                    <Trash2 size={16} className="text-purple-accent" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KBUpload;
